import { Box, HStack, Table, Tbody, Text, Th, Thead, Tr, VStack } from "@chakra-ui/react";
import PatientProfileEditModeButton from "../../../../entityProfileModal/components/EntityProfileEditModeButton";
import {
  entityProfileModalBorders,
  entityProfileModalColors,
} from "../../../../entityProfileModal/entityProfileModal.theme";
import type { PatientProfilePatient } from "../../../patientProfileModal.types";
import { usePatientProfileAddressesController } from "./PatientProfileAddressesSection.hooks";
import { ExistingAddressRow, NewAddressRow } from "./components/AddressRows";
import EntityModalButton from "../../../../entityProfileModal/components/EntityModalButton";

type Props = {
  patient: PatientProfilePatient;
};

export default function PatientProfileAddressesSection(props: Props) {
  const controller = usePatientProfileAddressesController(props.patient);

  return (
    <VStack alignItems="stretch" spacing={4}>
      {controller.canEdit ? (
        <HStack justifyContent="flex-end">
          {controller.isEditing ? (
            <EntityModalButton
              iconClassName="fa fa-plus"
              kind="white"
              size="sm"
              onClick={controller.startAdding}
            >
              Add Address
            </EntityModalButton>
          ) : null}
          <PatientProfileEditModeButton
            isEditing={controller.isEditing}
            label="Edit"
            onClick={controller.toggleEditMode}
          />
        </HStack>
      ) : null}

      {props.patient.addresses.length === 0 && !controller.isAdding ? (
        <Box
          bg={entityProfileModalColors.surfaceMuted}
          border={entityProfileModalBorders.panel}
          borderRadius="2px"
          px={4}
          py={5}
        >
          <Text color={entityProfileModalColors.muted}>No addresses</Text>
        </Box>
      ) : (
        <Box border={entityProfileModalBorders.default} borderRadius="2px" overflowX="auto">
          <Table size="sm" variant="simple">
            <Thead bg={entityProfileModalColors.panelHeaderBg}>
              <Tr>
                <Th minW="325px">Address</Th>
                <Th>Address 2</Th>
                <Th>Location</Th>
                <Th minW="225px">Phones</Th>
                <Th>Notes</Th>
                <Th>Primary</Th>
                {controller.isEditing ? <Th /> : null}
              </Tr>
            </Thead>
            <Tbody>
              {controller.draftAddresses.map((address, index) => (
                <ExistingAddressRow
                  key={address.id}
                  actions={{
                    isDeleting: controller.deleteAddressMutation.isPending,
                    isSaving: controller.saveAddressMutation.isPending,
                    onDeleteAddress: controller.handleDeleteAddress,
                    onSaveAddress: controller.handleSaveAddress,
                  }}
                  address={address}
                  index={index}
                  isEditing={controller.isEditing}
                  patient={props.patient}
                  wasDraftSubmitted={controller.wasDraftSubmitted}
                  onUpdateAddress={controller.updateDraftAddress}
                />
              ))}
              {controller.isAdding ? (
                <NewAddressRow
                  actions={{
                    isSaving: controller.saveAddressMutation.isPending,
                    onCancel: controller.cancelAdding,
                    onSaveAddress: controller.handleSaveAddress,
                  }}
                  address={controller.newAddress}
                  patient={props.patient}
                  wasDraftSubmitted={controller.wasDraftSubmitted}
                  onChange={controller.setNewAddress}
                />
              ) : null}
            </Tbody>
          </Table>
        </Box>
      )}
    </VStack>
  );
}
